type CriteriumTypes = 'good' | 'average' | 'bad' | 'none';
type CriteriumStatusTypes = 'good' | 'average' | 'bad' | 'neutral';
type CriteriumTypeTypes = 'bullet-success' | 'bullet-warning' | 'bullet-danger' | 'bullet-plain';
type CriteriumTextTypes = 'crits_green' | 'crits_orange' | 'crits_red' | 'crits_info';
type CriteriumColorTypes = 'success' | 'warning' | 'error' | 'grey';
type CriteriumEventTypes = 'passed' | 'improve' | 'error' | 'informational'

interface CriteriumProps {
  status: CriteriumStatusTypes
  type: CriteriumTypeTypes
  text: CriteriumTextTypes
  color: CriteriumColorTypes
  event: CriteriumEventTypes
}

export const CRITERIUM_STATUS: {
  [key in CriteriumTypes]: CriteriumProps
} = {
  good: {
    status: 'good',
    type: 'bullet-success',
    text: 'crits_green',
    color: 'success',
    event: 'passed'
  },
  average: {
    status: 'average',
    type: 'bullet-warning',
    text: 'crits_orange',
    color: 'warning',
    event: 'improve'
  },
  bad: {
    status: 'bad',
    type: 'bullet-danger',
    text: 'crits_red',
    color: 'error',
    event: 'error'
  },
  none: {
    status: 'neutral',
    type: 'bullet-plain',
    text: 'crits_info',
    color: 'grey',
    event: 'informational'
  }
};

export const getStatusObject = (status: string | null) : CriteriumProps => {
  switch (status) {
    case 'bad':
      return CRITERIUM_STATUS.bad;
    case 'average':
      return CRITERIUM_STATUS.average;
    case 'good':
      return CRITERIUM_STATUS.good;
    default:
      return CRITERIUM_STATUS.none;
  }
};
